import React from 'react';

interface TimeInPropertyProps {
  years: number;
  months: number;
  onYearsChange: (years: number) => void;
  onMonthsChange: (months: number) => void;
}

const TimeInProperty: React.FC<TimeInPropertyProps> = ({
  years,
  months,
  onYearsChange,
  onMonthsChange
}) => {
  return (
    <div className="flex gap-2">
      <div className="flex-1">
        <select
          value={years}
          onChange={(e) => onYearsChange(parseInt(e.target.value))}
          className="w-full p-1.5 border rounded text-sm"
          required
        >
          {Array.from({ length: 21 }, (_, i) => (
            <option key={i} value={i}>
              {i} {i === 1 ? 'year' : 'years'}
            </option>
          ))}
        </select>
      </div>
      <div className="flex-1">
        <select
          value={months}
          onChange={(e) => onMonthsChange(parseInt(e.target.value))}
          className="w-full p-1.5 border rounded text-sm"
          required
        >
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i} value={i}>
              {i} {i === 1 ? 'month' : 'months'}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default TimeInProperty;